// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse {
    static getAttributeTypeMap() {
        return ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse.attributeTypeMap;
    }
}
ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse.discriminator = undefined;
ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse.additionalProperties = false;
ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse.js.map